import { handleRequest } from "../utilities/requestHandler";

export const getRecentOrdersBySite = ({ site_number, site_id, cus_id, limit = 3 }) =>
	handleRequest("post", "/orders/getRecentOrdersBySite", { site_number, site_id, cus_id, limit });

export const searchTrackOrders = ({ site_number, site_id, cus_id, searchTerm, signal }) =>
	handleRequest("post", "/orders/searchTrackOrders", { site_number, site_id, cus_id, searchTerm }, signal ? { signal } : {});

export const getOrderFullDetails = ({ order_number, site_number, site_id, cus_id }) =>
	handleRequest("post", "/orders/getOrderFullDetails", { order_number, site_number, site_id, cus_id });
